// extracted by mini-css-extract-plugin
export var text = "post-layout-module--text--1HeF3";
export var articleAuthor = "post-layout-module--articleAuthor--2_j4L";
export var section = "post-layout-module--section--3UoqV";